export const juniorBusinessDevelopmentResume = `
【職務概要】
私は事業開発として約3年の経験を持ち、新規ビジネス機会の創出と既存事業の戦略的拡大に携わってきました。特にAI・SaaS領域でのビジネスモデル構築と、デジタルトランスフォーメーションを軸とした企業間アライアンス構築に強みを持っています。アイデア段階から事業化までのプロセスを一貫して担当し、市場分析・競合調査・顧客インサイト収集を通じて戦略的な事業計画を立案してきました。

これまで複数の業界にまたがる事業開発を経験し、リサーチから企画立案、社内外のステークホルダーとの交渉、パートナーシップ構築まで幅広く担当してきました。特に新規事業立ち上げにおいては、スケールする仮説の構築と検証を繰り返すリーンな開発アプローチを実践し、収益化までの道筋を具体化した経験があります。今後は、先端技術の社会実装とビジネスモデルイノベーションを両立させる事業開発のスペシャリストとして、より大きな社会的インパクトを創出していきたいと考えています。

【職務経歴】
・株式会社AlgomaticTech（AI技術開発・提供企業）
  ○ 会社概要：法人向けAI会議文字起こしツール等を提供するテック企業（従業員約80名）
  ○ 就業期間：2023年4月〜現在
  ○ 職務内容：事業開発マネージャー
    - AI会議文字起こしツールの大手企業向け提案戦略の策定と推進
    - LLMを活用した新規ソリューション企画（営業支援ツール・HR向けAIマッチングシステム）
    - パートナーシップ戦略立案と提携交渉（SIer、クラウドサービス事業者との協業体制構築）
  ○ 具体的な成果：
    - 年間受注目標の138%を達成（契約数前年比200%増）
    - 大手金融機関・製造業5社との実証実験プロジェクトを立上げ、3社との長期契約を獲得
    - 国内SIer 2社とのリセラー契約の締結と、初年度売上1.2億円の達成
  ○ 使用した技術・ツール：
    - Salesforce、Tableau（案件管理・データ分析）
    - 音声認識API、LLM APIの基本仕様理解と活用
  ○ 身につけたスキル：
    - エンタープライズ向けAIソリューションの事業開発手法
    - PoC（概念実証）から本格導入までの顧客伴走型アプローチ設計
    - テクニカルセールスとプロダクト部門の連携促進ノウハウ

・株式会社AlgomaticSolutions（ITコンサルティングファーム）
  ○ 会社概要：デジタル戦略コンサルティングと実装支援を行う企業（従業員約150名）
  ○ 就業期間：2021年4月〜2023年3月
  ○ 職務内容：コンサルタント（事業開発チーム）
    - デジタルトランスフォーメーション推進支援（製造業・小売業中心）
    - 顧客企業の新規事業開発支援（市場調査・競合分析・事業計画策定）
    - IoTを活用した製造現場の業務効率化プロジェクト推進
  ○ 具体的な成果：
    - 製造業クライアント向けIoTソリューション導入による生産性20%向上の実現
    - 小売チェーン向けオムニチャネル戦略立案と導入支援（年商5%増加に貢献）
    - 社内向けDX人材育成プログラムの企画・立案（受講者40名、満足度89%）
  ○ 使用した技術・ツール：
    - Tableau、PowerBIを活用したデータ分析
    - PM支援ツール（Asana、JIRA）
    - ビジネスモデルキャンバス、リーンキャンバス等のフレームワーク
  ○ 身につけたスキル：
    - 業種別DX戦略立案手法
    - データドリブンな事業計画策定能力
    - プロジェクトマネジメント基礎（スコープ・進捗・品質管理）

・株式会社AlgomaticJapan（総合商社）
  ○ 会社概要：国内大手総合商社の新規事業開発部門（従業員約2,000名）
  ○ 就業期間：2020年4月〜2021年3月
  ○ 職務内容：新規事業開発担当（デジタル事業開発チーム）
    - 農業テック領域における新規ビジネス機会の探索
    - デジタルプラットフォーム事業の市場調査と事業性評価
    - スタートアップ投資候補企業の発掘と事業シナジー検討
  ○ 具体的な成果：
    - 農業データプラットフォーム事業の事業計画策定（3年計画）
    - 国内スタートアップ2社との協業モデル構築（PoC実施）
    - 農業DXに関する社内勉強会の企画運営（参加者100名以上）
  ○ 使用した技術・ツール：
    - Excel、PowerPointによる事業計画モデリング
    - 市場調査ツール（Speeda、Crunchbase）
  ○ 身につけたスキル：
    - 新規事業企画の基礎フレームワーク活用
    - スタートアップと大企業の協業スキーム設計
    - 事業性評価の定量・定性分析手法

【受賞・表彰歴】
・2023年 株式会社AlgomaticTech 「社長賞」受賞（大手SIerとのアライアンス構築による事業拡大への貢献）
・2022年 株式会社AlgomaticSolutions 「イノベーション賞」受賞（小売業DX推進プロジェクトでの顧客満足度向上）
・2022年 DX人材育成コンテスト 「優秀プロジェクト賞」（社内チームで応募）

【資格】
・2023年2月 AI活用ビジネスプランナー認定資格
・2021年11月 ITパスポート
・2021年8月 PMP（Project Management Professional）
・2020年12月 TOEIC 850点

【マネジメント経験】
・株式会社AlgomaticTech
  ○ プロジェクトリーダーとして3名のチームをマネジメント（大手製造業向けAI導入プロジェクト）
  ○ SIerパートナー向け技術研修を企画・実施（累計40名）
  ○ アライアンスパートナー5社との定例会議運営と協業案件の進捗管理

・株式会社AlgomaticSolutions
  ○ 若手コンサルタント（1〜2年目）2名のメンター担当
  ○ クライアントとの共同プロジェクトにおける横断チーム（5名）のマネジメント

【語学力】
・英語：ビジネスレベル（TOEIC 850点）
  ○ 海外パートナー企業とのミーティング対応
  ○ 英文契約書や技術資料の読解・作成
  ○ 国際カンファレンス参加と情報収集
` as const;
